import { forwardRef } from "react";

import { Form } from "@shared/components";
import { FormAutocompleteProps } from "@shared/components/Form/types";
import { getStoresService } from "@modules/stores/services/queries/listStores/service";

export const StoresAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {

  return (
    <Form.Autocomplete
      {...props}
      ref={ref}
      labelField="full_name"
      queryHook={getStoresService}
    />
  );
});

StoresAutocomplete.displayName = "StoresAutocomplete";
